import { Dispatch, SetStateAction, useState } from "react";
import { SubscriptionRenewalModal } from "../../pages/subscriptions/SubscriptionRenewalModal";
import { useNavigate } from "@reach/router";
import { useDispatch, useSelector } from 'react-redux';
import { selectCancelSubConfirmMsg, setCancelSubConfirmMsg } from 'reducers/misc';
import { SubscriptionCancelMsgModal } from "../../pages/subscriptions/SubscriptionCancelMsgModal";

type Props = {
  renewSubDetails: renewSubDetailsProps[];
  isMainAccountUser: boolean;
  mainAccountHolders: any;
  setError: Dispatch<SetStateAction<string>>;
};

type renewSubDetailsProps = {
  renewalDays: number;
  renewalYears: number;
  accountPackageID: number;
  subject: string;
  isFreeTrial: boolean | null;
  bExpired: boolean | null;
};

const SubscriptionRenewalBanner: React.FC<Props> = ({
  renewSubDetails,
  isMainAccountUser,
  mainAccountHolders,
  setError,
}) => {
  const [openSubPopup, setOpenSubPopup] = useState<boolean>(false);
  const [accountPackageID, setAccountPackageID] = useState<number>(0);

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const openCancelMsgModal = useSelector(selectCancelSubConfirmMsg);
  
  return (
    <>
      {renewSubDetails.map((item: renewSubDetailsProps, index: number) => {
        if(item.renewalDays > 0 && item.isFreeTrial !== true && item.bExpired !== true){
          return (
            <div className={"SubscriptionRenewalBannerContainer" + (((index + 1) === renewSubDetails.length) ? " LastBanner" : "")}>
              <div className="SubscriptionRenewalBanner WidthContent">
                <span>There {item.renewalDays > 1 ? `are ${item.renewalDays} days` : `is ${item.renewalDays} day`} left of your '{item.subject}' subscription. Don't worry, you are set to auto-renew on a {item.renewalYears} year package with your discount applied. To pay by card or upgrade your subscription, click ‘Manage Subscription’.</span>

                <button
                  onClick={() => {
                    if(isMainAccountUser){
                      navigate("/manage-school");
                    } else {
                      setOpenSubPopup(true);
                    }
                  }}
                  className="Btn BtnOrange TileButton SlimButton"
                >
                  Manage Subscription
                </button>

                {isMainAccountUser &&
                  <button
                    onClick={() => {
                      dispatch(setCancelSubConfirmMsg(true));
                      setAccountPackageID(item.accountPackageID);
                    }}
                    className="Btn BtnOrange TileButton SlimButton"
                  >
                    Cancel Auto-Renew
                  </button>
                }
              </div>         
            </div>
          );
        } else {
          return null;
        }
      })}

      {openSubPopup && (
        <SubscriptionRenewalModal
          panelOpen={openSubPopup}
          togglePanelOpen={setOpenSubPopup}
          mainAccountHolders={mainAccountHolders}
        />
      )}

      {openCancelMsgModal &&
        <SubscriptionCancelMsgModal 
          accountPackageID={accountPackageID}  
          setAccountPackageID={setAccountPackageID}    
          setError={setError}  
        />  
      }               
    </>
  );
};

export default SubscriptionRenewalBanner;
